/* eslint-disable react/no-danger */
import { Breadcrumb } from "@components/anti/Breadcrumb"
import SectionFullSlider from "@components/global/SectionFullSlider"
import { linkOurCommitment } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, formatDate, imgUrl } from "src/mixins"

function SocialInitiativeDetail({ data, locale }) {
  const [trigger, anim] = useScrollAnim("fadeInUp", 0.125)
  return (
    <section className="sc-social-initiative-detail">
      <div className="container">
        <Breadcrumb
          path={[
            {
              title: translations[`our_commitment_${locale}`],
              url: `${linkOurCommitment}`,
            },
            {
              title: translations[`social_initiatives_${locale}`],
              url: `${linkOurCommitment}/social-initiative`,
            },
            {
              title: data[`title_${locale}`],
            },
          ]}
        />
      </div>
      <div className="py-main">
        <div className="container mw-lg">
          <div ref={trigger}>
            <SectionFullSlider
              imgHeight="h-auto h-md-600px"
              sectionName="sc-social-initiative-detail__cover"
              data={Array(1)
                .fill()
                ?.map(() => ({
                  title: "",
                  text: "",
                  img: imgUrl(data?.featured_image),
                  imgMd: imgUrl(data?.featured_image),
                }))}
            />
            <p className="sc-social-initiative-detail__tags">
              {formatDate(data?.published_at)}
            </p>
            <h1 className="title mb-4">{data && data[`title_${locale}`]}</h1>
            <div className="sc-social-initiative-detail__content">
              {convertHtmlToReact(data[`content_${locale}`])}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SocialInitiativeDetail
